import http from '../../api/http'

function getSystemCodeValues(codeName) {
    return http.get(`system/code/retrieveWithValues?codeName=${codeName}`);
}

export default {
    getSystemCodeValues,
};